<template>
  <div>
    Please wait
  </div>
</template>

<script>
import store from "@/store"
import { mapState } from 'vuex'

export default {
  created: function () {
    this.initCheckout()

  },
  data: () => ({
    
  }),
  methods: {
    initCheckout: function () {

      this.$store.dispatch("payments/stripeSessionA")
      .then((res) => {
        console.log(res)
        console.log(res.id)
        stripe.redirectToCheckout({
          sessionId: res.data.id // res.id
        }).then(function (result) {
          console.log(result)
        });
      }) 
    }
  },

  computed: {
        ...mapState({
          sessionId: state => state.payments.sessionId, 
        }),
      },
}
</script>